/**
 * @generated SignedSource<<8947e621d9ff2ca37aa3c8a7db11ba72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountConnectDetailInlineFragment$data = {
  readonly type: string | null;
  readonly meetSubdomain: string;
  readonly businessNumber: string | null;
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly " $fragmentType": "accountConnectDetailInlineFragment";
};
export type accountConnectDetailInlineFragment$key = {
  readonly " $data"?: accountConnectDetailInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "accountConnectDetailInlineFragment"
};

(node as any).hash = "571d8c6b83231d128a0f2dd507bd940d";

export default node;
